import { Link } from "react-router-dom";
import { Target, Users, Briefcase, Globe, Check, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const services = [
  {
    icon: Target,
    title: "Coaching individuale",
    desc: "Un percorso 1:1 per superare blocchi, chiarire obiettivi e ritrovare energia e motivazione.",
    points: ["Sessioni personalizzate", "Obiettivi misurabili", "Supporto costante"],
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/f2ojxqeu_625007474_18559486366047014_3106164551789998707_n.jpg",
  },
  {
    icon: Users,
    title: "Percorsi personalizzati",
    desc: "Programmi strutturati su più sessioni, costruiti attorno alle tue specifiche esigenze di crescita.",
    points: ["Piano su misura", "Follow-up dedicati", "Materiali esclusivi"],
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/620qiwt4_588971601_18549488503047014_6661371983574925503_n.jpg",
  },
  {
    icon: Briefcase,
    title: "Corsi aziendali",
    desc: "Formazione su vendita, marketing e organizzazione per team e imprese che vogliono crescere.",
    points: ["Vendita evoluta", "Leadership & team", "Organizzazione efficace"],
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/xt1f1l8x_588409364_1266858312149617_4286527763739232253_n.jpg",
  },
  {
    icon: Globe,
    title: "Formazione web & social",
    desc: "Costruisci un personal brand autentico ed efficace, e impara a comunicare online con impatto.",
    points: ["Personal branding", "Strategia social", "Comunicazione digitale"],
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/sfck5hpq_556832878_1219363500232432_8895874976842740320_n.jpg",
  },
];

const prices = [
  ["Sessione fisica", "100€", "all'ora"],
  ["Sessione telefonica", "50€", "all'ora"],
  ["Coaching via chat", "100€", "al giorno"],
];

export const Services = () => (
  <div className="pt-32 pb-24 relative z-10">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal>
        <p className="eyebrow mb-4">Servizi</p>
        <h1 className="font-display text-4xl sm:text-6xl text-white max-w-3xl leading-tight">Percorsi di coaching e formazione, su misura.</h1>
      </Reveal>

      <div className="mt-16 space-y-8">
        {services.map((s, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <div data-testid={`service-card-${i}`} className={`grid lg:grid-cols-2 gap-0 bg-[#121212] border border-white/10 rounded-2xl overflow-hidden ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
              <div className="img-zoom h-64 lg:h-auto [direction:ltr]">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-8 lg:p-12 [direction:ltr]">
                <div className="h-12 w-12 rounded-full bg-[#C19A5B]/15 flex items-center justify-center text-[#C19A5B] mb-5">
                  <s.icon size={22} />
                </div>
                <h2 className="font-display text-3xl text-white mb-4">{s.title}</h2>
                <p className="text-zinc-400 leading-relaxed mb-6">{s.desc}</p>
                <ul className="space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-zinc-300">
                      <Check size={16} className="text-[#C19A5B]" /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Pricing */}
      <div className="mt-24">
        <Reveal><h2 className="font-display text-3xl sm:text-4xl text-white mb-4">Tariffe coaching individuale</h2></Reveal>
        <Reveal delay={0.1}><p className="text-zinc-400 mb-12 max-w-xl">Il primo colloquio è sempre gratuito e senza impegno.</p></Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {prices.map(([label, price, unit], i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="hover-lift bg-[#121212] border border-white/10 rounded-xl p-8 text-center">
                <p className="text-zinc-400 mb-4">{label}</p>
                <p className="font-display text-5xl gold-text">{price}</p>
                <p className="text-zinc-500 text-sm mt-2">{unit}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-20 text-center">
        <Link to="/contatti" data-testid="services-cta" className="inline-flex items-center gap-2 rounded-full bg-[#C19A5B] text-black font-semibold px-8 py-4 hover:bg-[#D4AF37] transition-colors">
          Prenota il tuo colloquio gratuito <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  </div>
);

export default Services;
